import(/* webpackMode: "eager" */ "/vercel/path0/src/app/musicraft/apply/page.tsx");
